export const disabilityGroupForms = ['I', 'II', 'III'].map(l => ({ name: l, key: l, label: l }));

export const getDisabilityGroupFormsOptions= () => {
    return disabilityGroupForms.map(item => ({
        key: item.key,
        value: item.name,
        text: item.label
    }))
}